<udex-masthead-shell
  id="masthead-shell"
  home-url="https://www.sap.com"
  logo-title="SAP"
  site-label-aria-label="SAP Store"
  homepage-aria-label="SAP Homepage"
  close-button-accessible-name="Close Search"
  logo-alt="SAP Logo"
  logo-url="https://cdn.udex.services.sap.com/dds/design-tokens/assets/logos/sap-logo.svg"
  site-label-url="https://store.sap.com/"
  body-overflow>

  <!-- items on the left -->
  @let mainLinksNavigation = mainLinksNavigationData();
  @for (link of mainLinksNavigation; track $index) {
    <udex-masthead-item
      [attr.accessible-name]="link.title || 'Menu item'"
      hide-arrow-icon>
      {{link.title}}
      <udex-masthead-menu
        slot="dropdown"
        [attr.sub-items]="link.subMenuRows | json">
      </udex-masthead-menu>
    </udex-masthead-item>
  }

  <!-- items on the right -->
  @let exploreSapNavigation = exploreSapNavigationData();
  @if (exploreSapNavigation) {
    <udex-masthead-item
      accessible-name="Explore SAP"
      slot="exploreSAP"
      hide-arrow-icon
      class="explore-sap-item">
      {{exploreSapNavigation.title}}
      <udex-masthead-menu
        class="text-grey"
        [attr.menu-title]="exploreSapNavigation.displayTitle"
        slot="dropdown"
        [attr.sub-items]="exploreSapNavigation.subMenuRows | json">
      </udex-masthead-menu>
    </udex-masthead-item>
  }

  <udex-search
    id="search"
    label="Search"
    language-voice="en-US"
    mode="Home Search"
    show-submit-button
    slot="search"
    (submit-search-value)="submitSearch($any($event))"
    (keydown.enter)="submitSearch($any($event))"
  >
  </udex-search>

  @if (isUserLoggedIn()) {
    <udex-masthead-item slot="profile">
      <udex-avatar
        #udexAvatar
        accessible-name="profile"
        color-scheme="Blue"
        [initials]="(user?.avatarInitials)"
        interactive
        shape="Circle"
        size="XS">
      </udex-avatar>
      <udex-masthead-profile-menu
        id="profile-menu"
        slot="dropdown"
        [links]="userMenuConfig"
        [attr.logged-in-user]="user ? (user | json) : ''"
        logout-url="/logout">
      </udex-masthead-profile-menu>
    </udex-masthead-item>
  } @else {
    <udex-masthead-item slot="profile" icon="person-placeholder" (item-click)="onLogin()">
    </udex-masthead-item>

    @let countries = countriesData();
    <udex-masthead-item
      icon="sap-icon://world"
      image-alt="Globe icon for selecting country"
      accessible-name="country selector"
      slot="countrySelector">
      <udex-masthead-country-selector
        id="country-selector"
        slot="dropdown"
        country-title="Choose your Country"
        region-title="Choose your Region"
        search-label="Search"
        language-voice="en-US"
        [attr.regions]='countries ? (countries | json) : ""'
        (country-item-click)="onCountrySelected($any($event)?.detail?.item?.countryCode)">
      </udex-masthead-country-selector>
    </udex-masthead-item>
  }

  <udex-masthead-mobile-menu id="mobile-menu" slot="mobileMenu">
    <udex-search
      slot="search"
      id="mobile-search"
      label="Search"
      language-voice="en-US"
      mode="Home Search"
      show-submit-button
      (submit-search-value)="submitSearch($any($event))"
      (keydown.enter)="submitSearch($any($event))">
    </udex-search>
    @for (link of mainLinksNavigation; track $index) {
      <udex-masthead-item
        [attr.accessible-name]="link.title || 'Menu item'"
        [attr.sub-items]="link.subMenuRows | json">
        {{link.title}}
      </udex-masthead-item>
    }

    @if (exploreSapNavigation) {
      <udex-masthead-item
        accessible-name="Explore SAP"
        slot="exploreSapMobileButton"
        [attr.sub-items]="exploreSapNavigation.subMenuRows | json">
        {{exploreSapNavigation.title}}
      </udex-masthead-item>
    }
  </udex-masthead-mobile-menu>
</udex-masthead-shell>
